import styled from 'styled-components';

export const SettingItemLayout = styled.div`
  margin-top: 24px;
  padding: 24px 12px 12px;
  border-top: 1px solid #000;
  min-width: 600px;
`;
